<div class="timezone-warning-container">
  <div class="header">
    <img src="assets/img/icons/clock-yellow.svg" />
    <h2>Timezone change!</h2>
  </div>

  <p>
    Your timezone appears to be <strong>{{ newTimezone }}</strong
    >. Do you want to switch to it?
  </p>
  <p class="mt-6">
    Your timezone is set to: <strong>{{ currentTimezone }}</strong>
  </p>

  <div class="checkbox-row">
    <oph-checkbox
      [text]="'Change my skeds to ' + newTimezone"
      textOrientation="right"
      [textStyle]="{color: 'var(--off-black)'}"
      [checked]="changeSkeds()"
      (valueChange)="onCheckbox($event)"
      [width]="20"
      color="green"
      [gap]="6"
    ></oph-checkbox>
    <button class="learn-more-button" (click)="onLearnMore()">
      <img src="assets/img/icons/info-2.svg" />
    </button>
  </div>

  @if (showTooltip()) {
    <div class="tooltip-container">
      <p>The clock times (e.g., 1pm - 2pm) will remain unchanged but will now represent the new timezone.</p>
      <oph-x-button [width]="16" (buttonClick)="onLearnMore()"></oph-x-button>
    </div>
  }

  <div class="button-container">
    <oph-button
      appearance="outline"
      color="gray"
      [style]="{
        color: 'var(--brown-med)',
        minWidth: '0',
        width: '100px',
        height: '34px',
        padding: '0',
        fontWeight: '400',
        backgroundColor: 'var(--lightest)'
      }"
      (click)="onKeep()"
      >Keep</oph-button
    >
    <oph-button
      color="green"
      [style]="{'border-radius': '8px', height: '33px', width: '130px'}"
      [loading]="loadingSwtich()"
      (click)="onSwitch()"
      >Switch</oph-button
    >
  </div>
</div>
